import React, { Component, Fragment } from "react";
import ReactGA from "react-ga";
import Servicios from "../../servicios/contenedor";
import NavBarComponent from "../../utilerias/nav";
import MenuComponent from "../../utilerias/menu";
import ServiciosEs from "../../utilerias/español/serviciosES.json";
import Ingles from "../../utilerias/ingles/serviciosEN.json";

export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guardarIdioma: "",
      guardarNuevoIdioma: true,
      idiomaNavegador: navigator.language || navigator.userLanguage,
      componente: "",
      separador: "-",
      idiomaCadena: navigator.language,
      storage: JSON.parse(localStorage.getItem("español")),
      statusMenu: false,
    };
  }

  UNSAFE_componentWillMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        this.setState({ guardarIdioma: Ingles });
        this.setState({ componente: "services" });
        this.setState({ guardarNuevoIdioma: false });
      } else {
        this.setState({ guardarIdioma: ServiciosEs });
        this.setState({ componente: "servicios" });
        this.setState({ guardarNuevoIdioma: true });
      }
    } else {
      if (storage !== null && storage === false) {
        this.setState({ guardarIdioma: ServiciosEs });
        this.setState({ componente: "servicios" });
        this.setState({ guardarNuevoIdioma: true });
      } else {
        this.setState({ guardarIdioma: Ingles });
        this.setState({ componente: "services" });
        this.setState({ guardarNuevoIdioma: false });
      }
    }
  }

  componentDidMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        document.getElementById("text-lang").innerHTML = "ENG";
      } else {
        document.getElementById("text-lang").innerHTML = "ESP";
      }
    } else {
      if (storage !== null && storage === false) {
        document.getElementById("text-lang").innerHTML = "ESP";
      } else {
        document.getElementById("text-lang").innerHTML = "ENG";
      }
    }
  }
  render() {
    const openNav = () => {
      ReactGA.event({
        category: "Button",
        action: "Se ha dado click en el apartado del nav",
      });
      this.setState({ statusMenu: true });
      const x = window.matchMedia("(max-width: 999px)");
      if (x.matches === true) {
        document.getElementById("myNav").style.height = "110%";
      } else {
        document.getElementById("myNav").style.height = "100%";
      }
      document.getElementsByTagName("html")[0].style.overflowY = "hidden";
      document.getElementById("myNav").style.overflowY = "auto";
    };

    const closeNav = () => {
      this.setState({ statusMenu: false });
      document.getElementsByTagName("html")[0].style.overflowY = "visible";
      document.getElementById("myNav").style.height = "0%";
    };

    const cambiarIdioma = () => {
      if (this.state.guardarNuevoIdioma) {
        this.setState({ guardarIdioma: Ingles });
        this.setState({ guardarNuevoIdioma: false });
        this.setState({ componente: "services" });
        localStorage.setItem("español", true);
        document.getElementById("text-lang").innerHTML = "ENG";
      } else {
        this.setState({ guardarIdioma: ServiciosEs });
        this.setState({ guardarNuevoIdioma: true });
        this.setState({ componente: "servicios" });
        localStorage.setItem("español", false);
        document.getElementById("text-lang").innerHTML = "ESP";
      }
    };
    return (
      <Fragment>
        <NavBarComponent
          closeNav={closeNav}
          openNav={openNav}
          statusMenu={this.state.statusMenu}
          cambiarIdioma={cambiarIdioma}></NavBarComponent>
        <MenuComponent
          closeNav={closeNav}
          cambiarIdioma={this.state.guardarNuevoIdioma}
        ></MenuComponent>
        <Servicios
          componente={this.state.componente}
          idiomaNavegador={this.state.idiomaNavegador}
          servicios={this.state.guardarIdioma}
        ></Servicios>
      </Fragment>
    );
  }
}

export default Home;
